class MemberDAO {
    constructor(baseURL) {
   
        //use singleton pattern
        if (MemberDAO.instance) {
            return MemberDAO.instance;
        }

        this.baseURL = baseURL;
        this.baseURL = process.env.VUE_APP_HTTP_BASE_URL;
        this.ws = null;
        this.public_ws = null;
        this.authToken = null;
        this.eventListeners = {};
        this.messageQueue = []; // Add message queue for pending messages


        MemberDAO.instance = this;

        this.connectPublicWebSocket();
    }

    /**
     * Registers an event listener for a specific event.
     * @param {string} event - The event name.
     * @param {function} callback - The callback function.
     */
    on(event, callback) {
        if (!this.eventListeners[event]) {
            this.eventListeners[event] = [];
        }
        this.eventListeners[event].push(callback);
    }


    off(event, callback) {
        if (event === 'wsMessage') {
            if (this.eventListeners[event]) {
                if (callback) {
                    this.eventListeners[event] = this.eventListeners[event].filter(cb => cb !== callback); // Remove specific event listener
                }
            }
            // else {
            // delete this.eventListeners[event]; // Remove event listener
        } else {
            delete this.eventListeners[event]; // Remove event listener
        }
    }
    /**
     * Emits an event to all registered listeners.
     * @param {string} event - The event name.
     * @param {any} data - The data to pass to the listeners.
     */
    emit(event, data) {
        console.log('Emitting event:', event, data);
        console.log('Event listeners:', this.eventListeners[event]);
        if (this.eventListeners[event]) {
            this.eventListeners[event].forEach(callback => callback(data));
        }
    }

    async register(username, password) {
        try {
            const response = await fetch(`${this.baseURL}/member_register`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password })
            });
    
            const data = await response.json();
    
            if (data.success) {
                console.log('MemberDAO Register successful!', JSON.stringify(data));
                return data;
            } else {
                throw new Error(data.message || 'Registration failed.');
            }
        } catch (error) {
            // alert(error.message);
            console.error('Error during registration:', error);
            // alert('Error during registration:', error.);
            throw new Error(error.message);
        }
    }    


    async reset_password(username, password) {
        try {
            const response = await fetch(`${this.baseURL}/reset_password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password })
            });
    
            const data = await response.json();
    
            if (data.success) {
                console.log('MemberDAO Reset Password successful!', JSON.stringify(data));
                return data;
            } else {
                throw new Error(data.message || 'Reset Password failed.');
            }
        } catch (error) {
            // alert(error.message);
            console.error('Error during Reset Password:', error);
            // alert('Error during registration:', error.);
            throw new Error(error.message);
        }
    }        



    /**
     * Logs in the member by sending credentials to the backend.
     * @param {string} username - The username.
     * @param {string} password - The password.
     */
    login(username, password) {
        fetch(`${this.baseURL}/member_login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ username, password })
        })
            .then(response => response.json())
            .then(data => {
                if (data.token) {
                    this.authToken = data.token;
                    // alert('MemberDAO Login successful!', data);
                    console.log('MemberDAO Login successful!', JSON.stringify(data));
                    this.emit('loginSuccess', data);
                    this.connectWebSocket();
                } else {
                    this.emit('loginFailure', data.message || 'Login failed.');
                }
            })
            .catch(error => {
                console.error('Error during login:', error);
                this.emit('loginFailure', 'An error occurred during login.');
            });
    }


    gettttOfferCards(row, page) {
        // console.log('Fetching offer cards:', row, page);
        fetch(`${this.baseURL}/offer_cards?row=${row}&page=${page}`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .then(data => {
                console.log('Offer cards data:', data);
                if (data.cards) {
                    // console.log('cards data:', data.cards);

                    this.emit('offerCardsSuccess', data.cards);
                } else {
                    this.emit('offerCardsFailure', data.message || 'Failed to fetch offer cards.');
                }
            })
            .catch(error => {
                console.error('Error fetching offer cards:', error);
                this.emit('offerCardsFailure', 'An error occurred while fetching offer cards.');
            });
    }

    /**
     * Establishes a WebSocket connection using the authentication token.
     */
    connectWebSocket() {
        if (!this.authToken) {
            this.emit('error', 'No authentication token found. Please log in.');
            return;
        }

        // Replace ws:// with wss:// if using HTTPS
        this.ws = new WebSocket(`${this.baseURL.replace('http', 'ws')}/member?token=${this.authToken}`);

        this.ws.onopen = () => {
            this.emit('wsOpen');
        };

        this.ws.onmessage = (event) => {
            try {
                const data = JSON.parse(event.data);
                this.emit('wsMessage', data);
            } catch (e) {
                this.emit('wsMessage', event.data);
            }
        };

        this.ws.onclose = () => {
            // this.ws.onclose = (event) => {
            this.emit('wsClose');
        };

        this.ws.onerror = (error) => {
            console.error('WebSocket error:', error);
            this.emit('wsError', 'WebSocket encountered an error.');
        };
    }

    /**
     * Disconnects the WebSocket connection.
     */
    disconnectWebSocket() {
        if (this.ws) {
            this.ws.close();
        }
    }

    connectPublicWebSocketX() {
        // this.public_ws = new WebSocket(`${this.baseURL.replace('http', 'ws')}/public`);
        this.public_ws = new WebSocket(`${this.baseURL.replace('http', 'ws')}/public`);

        this.public_ws.onopen = () => {
            console.log('Public WebSocket opened.');
        };

        this.public_ws.onmessage = (event) => {
            try {
                const data = JSON.parse(event.data);
                this.emit('pubicWSMessage', data);
            } catch (e) {
                console.error('Error parsing public WebSocket message:', e);
                this.emit('pubicWSMessage', event.data);

            }
        };

        this.public_ws.onclose = () => {
            console.log('Public WebSocket closed.');
        };

        this.public_ws.onerror = (error) => {
            console.error('Public WebSocket error:', error);
        };
    }

    tryConnectPublicWebSocket() {
        return new Promise((resolve, reject) => {
            this.public_ws = new WebSocket(`${this.baseURL.replace('http', 'ws')}/public`);
    
            this.public_ws.onopen = () => {
                console.log('Public WebSocket opened.');
                resolve();
            };
    
            this.public_ws.onmessage = (event) => {
                try {
                    const data = JSON.parse(event.data);
                    this.emit('pubicWSMessage', data);
                } catch (e) {
                    console.error('Error parsing public WebSocket message:', e);
                    this.emit('pubicWSMessage', event.data);
                }
            };
    
            this.public_ws.onclose = () => {
                console.log('Public WebSocket closed.');
            };
    
            this.public_ws.onerror = (error) => {
                console.error('Public WebSocket error:', error);
                reject(error);
            };
        });
    }


    async connectPublicWebSocket() {
        try {
            await this.tryConnectPublicWebSocket();
            console.log('WebSocket is connected. Proceeding with further actions.');
            // Add further actions here
        } catch (error) {
            console.error('Failed to connect to WebSocket:', error);
        }
    }
    
    // initializeWebSocket();

    disconnectPublicWebSocket() {

        if (this.public_ws) {
            this.public_ws.close();
        }
    }

    sendPublicMessage(message) {
        if (this.public_ws && this.public_ws.readyState === WebSocket.OPEN) {
            this.public_ws.send(JSON.stringify(message));
        } else {
            console.error('Public WebSocket is not connected.');
        }
    }


    async sendSms(phoneNumber, message) {
        const url = new URL(this.baseURL + '/send-sms');
        url.searchParams.append('phoneNumber', phoneNumber);
        url.searchParams.append('message', message);
    
        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    
            const data = await response.json();
    
            if (response.ok) {
                console.log('SMS sent successfully:', data.message);
            } else {
                console.error('Failed to send SMS:', data.message);
                throw new Error(data.message);
            }
        } catch (error) {
            console.error('An error occurred:', error.message);
            throw new Error(error.message);
        }
    }
    

    //get parking list from public websocket, use the same mechanism as the add card
    getParkingList(row, page) {
        if (!this.public_ws) {
            this.emit('error', 'Failed to getParkingList, Public WebSocket is not connected.');
            return;
        }
        return new Promise((resolve, reject) => {
            const message = {
                entity: 'parking',
                action: 'list_parkings',
                payload: {
                    row: row || 10,
                    page: page || 1
                }
                // entity: 'parking',
                // action: 'list_parkings',
                // payload: {
                //     ...filters,
                //     row,
                //     page
                // }                
            };
    
            // Listen for WebSocket response
            const handleMessage = (response) => {
                this.off('pubicWSMessage', handleMessage);
                console.log('Received publicWSMessage:', response);
                if (response.success && response.parkings) {
                    
                    if (response.success) {
                        // console.log('Resoving parking list:', response.parkings);
                        resolve(response); // Assuming the data is in response.data
                    } else {
                        reject(response.error || 'Failed to get parking list.');
                    }
                    // Clean up the event listener
                }
            };
    
            this.on('pubicWSMessage', handleMessage);
    
            // Send the message
            this.sendPublicMessage(message);
        });
    }


    
    //get parking list from public websocket, use the same mechanism as the add card
    getOfferList(row, page) {
        if (!this.public_ws) {
            this.emit('error', 'Failed to OfferList, Public WebSocket is not connected.');
            return;
        }
        return new Promise((resolve, reject) => {
            const message = {
                entity: 'offer',
                action: 'list_offers',
                payload: {
                    row: row || 10,
                    page: page || 1
                }
         
            };
    
            // Listen for WebSocket response
            const handleMessage = (response) => {
                this.off('pubicWSMessage', handleMessage);
                console.log('Received publicWSMessage:', response);
                if (response.success && response.offers) {
                    
                    if (response.success) {
                        // console.log('Resoving parking list:', response.parkings);
                        resolve(response); // Assuming the data is in response.data
                    } else {
                        reject(response.error || 'Failed to get offer list.');
                    }
                    // Clean up the event listener
                }
            };
    
            this.on('pubicWSMessage', handleMessage);
    
            // Send the message
            this.sendPublicMessage(message);
        });
    }




    /**
     * Sends a message through the WebSocket.
     * @param {Object} message - The message object to send.
     */
    sendMessageNoReconnet(message) {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            this.ws.send(JSON.stringify(message));
            this.emit('messageSent', message);
        } else {
            this.emit('error', 'WebSocket is not connected.');
           
        }
    }


    sendMessage(message) {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            this.ws.send(JSON.stringify(message));
            this.emit('messageSent', message);
        } else {
            console.log('WebSocket is not connected. Attempting to reconnect...');
            
            // Queue the message
            this.messageQueue.push(message);
            
            // Start reconnection process asynchronously (non-blocking)
            this.reconnectWebSocketAsync()
                .then(() => {
                    console.log('Reconnection successful, processing queued messages');
                    this.processMessageQueue();
                })
                .catch(error => {
                    console.error('Failed to reconnect WebSocket:', error);
                    this.emit('error', 'WebSocket reconnection failed: ' + error.message);
                    // Clear the queue and emit error for each queued message
                    this.messageQueue.forEach(queuedMessage => {
                        this.emit('messageFailed', {
                            message: queuedMessage,
                            error: 'Failed to send due to connection error'
                        });
                    });
                    this.messageQueue = [];
                });
        }
    }

    /**
     * Process all queued messages after successful reconnection
     */
    processMessageQueue() {
        while (this.messageQueue.length > 0 && this.ws && this.ws.readyState === WebSocket.OPEN) {
            const queuedMessage = this.messageQueue.shift();
            try {
                this.ws.send(JSON.stringify(queuedMessage));
                this.emit('messageSent', queuedMessage);
            } catch (error) {
                console.error('Failed to send queued message:', error);
                this.emit('messageFailed', {
                    message: queuedMessage,
                    error: error.message
                });
            }
        }
    }

    /**
     * Asynchronous reconnection that doesn't block execution
     * @returns {Promise<void>} - Resolves when connected, rejects on failure
     */
    async reconnectWebSocketAsync() {
        // Check if already reconnecting to avoid multiple simultaneous attempts
        if (this.isReconnecting) {
            console.log('Already attempting to reconnect');
            return this.reconnectPromise;
        }

        this.isReconnecting = true;
        this.reconnectPromise = this.reconnectWebSocket()
            .finally(() => {
                this.isReconnecting = false;
                this.reconnectPromise = null;
            });

        return this.reconnectPromise;
    }

    /**
     * Attempts to reconnect the WebSocket with retry logic
     * @returns {Promise<void>} - Resolves when connected, rejects on failure
     */
    async reconnectWebSocket() {
        const maxRetries = 3;
        const retryDelay = 1000; // 1 second
        
        for (let attempt = 1; attempt <= maxRetries; attempt++) {
            try {
                console.log(`Reconnection attempt ${attempt}/${maxRetries}`);
                
                // Close existing connection if any
                if (this.ws) {
                    this.ws.close();
                }
                
                // Wait for connection to be established
                await new Promise((resolve, reject) => {
                    this.connectWebSocket();
                    
                    const timeout = setTimeout(() => {
                        reject(new Error('Connection timeout'));
                    }, 5000); // 5 second timeout
                    
                    const handleOpen = () => {
                        clearTimeout(timeout);
                        this.off('wsOpen', handleOpen);
                        this.off('wsError', handleError);
                        resolve();
                    };
                    
                    const handleError = (error) => {
                        clearTimeout(timeout);
                        this.off('wsOpen', handleOpen);
                        this.off('wsError', handleError);
                        reject(error);
                    };
                    
                    this.on('wsOpen', handleOpen);
                    this.on('wsError', handleError);
                });
                
                console.log('WebSocket reconnected successfully');
                return; // Success
                
            } catch (error) {
                console.error(`Reconnection attempt ${attempt} failed:`, error);
                
                if (attempt === maxRetries) {
                    throw new Error(`Failed to reconnect after ${maxRetries} attempts`);
                }
                
                // Wait before next retry
                await new Promise(resolve => setTimeout(resolve, retryDelay));
            }
        }
    }


    addCard(offerCardId, cardType, cardNumber, expireDate) {
        return new Promise((resolve, reject) => {
            const accountId = this.getAccountIdFromToken();
            if (!accountId) {
                this.emit('error', 'Invalid authentication token.');
                reject('Invalid authentication token.');
                return;
            }

            const message = {
                entity: 'member',
                action: 'add_card',
                payload: {
                    account_id: accountId,
                    offer_card_id: offerCardId,
                    card_type: cardType.toLowerCase(),
                    card_number: cardNumber,
                    expire_date: expireDate
                }
            };

            console.log('Sending addcard message:', message);

            // Listen for WebSocket response
            const handleMessage = (response) => {
                // console.log('handing add_card response:', response);
                if (response.action === 'add_card') {
                    console.log('Received add_card response:', response);
                    if (response.success) {
                        resolve(response);
                    } else {
                        reject(response.error || 'Failed to add card.');
                    }
                    // Clean up the event listener
                    this.off('wsMessage', handleMessage);
                }
            };

            this.on('wsMessage', handleMessage);

            // Send the message
            this.sendMessage(message);
        });
    }

    /**
     * Deletes a credit card by sending a WebSocket message.
     * @param {number} cardId - The unique ID of the credit card to delete.
     */
    deleteCard(cardId) {
        const accountId = this.getAccountIdFromToken();
        if (!accountId) {
            this.emit('error', 'Invalid authentication token.');
            return;
        }

        const message = {
            entity: 'member',
            action: 'delete_card',
            payload: {
                account_id: accountId,
                card_id: cardId
            }
        };

        this.sendMessage(message);
    }


    deleteLP(lpId) {
        const accountId = this.getAccountIdFromToken();
        if (!accountId) {
            this.emit('error', 'Invalid authentication token.');
            return;
        }

        const message = {
            entity: 'member',
            action: 'delete_lp',
            payload: {
                account_id: accountId,
                lpid: lpId
            }
        };

        this.sendMessage(message);
    }


    addLP(lpId) {
        return new Promise((resolve, reject) => {
            const accountId = this.getAccountIdFromToken();
            if (!accountId) {
                this.emit('error', 'Invalid authentication token.');
                reject('Invalid authentication token.');
                return;
            }

            const message = {
                entity: 'member',
                action: 'add_lp',
                payload: {
                    account_id: accountId,
                    lpid: lpId
                }
            };

            console.log('Sending add_lp message:', message);

            // Listen for WebSocket response
            const handleMessage = (response) => {
                // console.log('handing add_card response:', response);
                if (response.action === 'add_lp') {
                    console.log('Received add_lp response:', response);
                    if (response.success) {
                        resolve(response);
                    } else {
                        reject(response.error || 'Failed to add lp.');
                    }
                    // Clean up the event listener
                    this.off('wsMessage', handleMessage);
                }
            };

            this.on('wsMessage', handleMessage);

            // Send the message
            this.sendMessage(message);
        });
    }


    readxxxxxxOfferCards(payload) {
        const message = {
            entity: 'member',
            action: 'read_offer_cards',
            payload: {
                row: payload.row || 10,
                page: payload.page || 1
            }
        };
        this.sendMessage(message);
    }


    /**
     * Extracts the account_id from the JWT token.
     * Assumes the JWT payload contains an 'account_id' field.
     * @returns {number|null} - The account_id or null if not found.
     */
    getAccountIdFromToken() {
        if (!this.authToken) return null;
        try {
            const payload = JSON.parse(atob(this.authToken.split('.')[1]));
            return payload.account_id || null;
        } catch (e) {
            console.error('Error parsing JWT token:', e);
            return null;
        }
    }



    /**
     * Queries the parking fee for a specific parking ID and car number.
     * @param {string} parking_id - The parking session ID.
     * @param {string} car_number - The car's license plate number.
     * @returns {Promise<Object>} - Resolves with parking fee data or rejects with an error.
     */
    queryParkingFee(parking_id, car_number) {
        if (!this.public_ws) {
            this.emit('error', 'Failed to query parking fee, Public WebSocket is not connected.');
            return;
        }
        // alert( parking_id);
        // alert( car_number);
        return new Promise((resolve, reject) => {
            const message = {
                entity: 'fee',
                action: 'query_parking_fee',
                payload: {
                    parking_id: parking_id,
                    car_number: car_number
                }
            };

            // Listen for WebSocket response
            const handleMessage = (response) => {
                // Ensure that the response is for the 'query_parking_fee' action
                if (response.action === 'query_parking_fee') {
                    this.off('pubicWSMessage', handleMessage);
                    console.log('Received query_parking_fee response:', response);
                    if (response.success && response.parking_fee !== undefined) {
                        resolve(response.parking_fee);
                    } else {
                        reject(response.error || 'Failed to query parking fee.');
                    }
                }
            };

            this.on('pubicWSMessage', handleMessage);

            // Send the message
            this.sendPublicMessage(message);
        });
    }

    /**
     * Queries the available discount hours for a specific parking ID, car number, and card number.
     * @param {string} parking_id - The parking session ID.
     * @param {string} car_number - The car's license plate number.
     * @param {string} card_number - The discount card number.
     * @returns {Promise<number>} - Resolves with available discount hours or rejects with an error.
     */
    queryCardDiscount(parking_id, car_number, card_number) {
        if (!this.public_ws) {
            this.emit('error', 'Failed to query card discount, Public WebSocket is not connected.');
            return;
        }
        return new Promise((resolve, reject) => {
            const message = {
                entity: 'fee',
                action: 'query_card_discount',
                payload: {
                    parking_id: parking_id,
                    car_number: car_number,
                    card_number: card_number
                }
            };

            // Listen for WebSocket response
            const handleMessage = (response) => {
                // Ensure that the response is for the 'query_card_discount' action
                if (response.action === 'query_card_discount') {
                    this.off('pubicWSMessage', handleMessage);
                    console.log('Received query_card_discount response:', response);
                    if (response.success && response.can_discount_hours !== undefined) {
                        resolve(response.can_discount_hours);
                    } else {
                        reject(response.error || 'Failed to query card discount.');
                    }
                }
            };

            this.on('pubicWSMessage', handleMessage);

            // Send the message
            this.sendPublicMessage(message);
        });
    }

    /**
     * Applies a discount to the parking fee using the specified discount hours.
     * @param {string} parking_id - The parking session ID.
     * @param {string} car_number - The car's license plate number.
     * @param {string} card_number - The discount card number.
     * @param {number} discount_hours - The number of hours to discount.
     * @returns {Promise<number>} - Resolves with the residual parking fee or rejects with an error.
     */
    applyCardDiscount(parking_id, car_number, card_number, discount_hours) {
        if (!this.public_ws) {
            this.emit('error', 'Failed to apply card discount, Public WebSocket is not connected.');
            return;
        }
        return new Promise((resolve, reject) => {
            const message = {
                entity: 'fee',
                action: 'apply_card_discount',
                payload: {
                    parking_id: parking_id,
                    car_number: car_number,
                    card_number: card_number,
                    discount_hours: discount_hours
                }
            };

            // Listen for WebSocket response
            const handleMessage = (response) => {
                // Ensure that the response is for the 'apply_card_discount' action
                if (response.action === 'apply_card_discount') {
                    this.off('pubicWSMessage', handleMessage);
                    console.log('Received apply_card_discount response:', response);
                    if (response.success && response.residual_fee !== undefined) {
                        resolve(response.residual_fee);
                    } else {
                        reject(response.error || 'Failed to apply card discount.');
                    }
                }
            };

            this.on('pubicWSMessage', handleMessage);

            // Send the message
            this.sendPublicMessage(message);
        });
    }

}

export default MemberDAO;